export default __webpack_public_path__ + "static/media/dep2_4.b926194d.png";